import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, User, Settings, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom"; // ✅ Add this

export function UserMenu() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate(); // ✅ Initialize navigate

  const userName = user?.attributes?.name || user?.name || "User";
  const userInitial = userName.charAt(0).toUpperCase();

  const handleProfileClick = () => {
    navigate("/profile"); // ✅ Navigate to profile page
  };

  const handleSOAPFormatClick = () => {
    navigate("/settings/soap-format");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="outline-none">
        <Avatar>
          <AvatarImage src={user?.attributes?.picture || ""} alt={userName} />
          <AvatarFallback className="bg-blue-500 text-white">
            {userInitial}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>My Account</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem className="cursor-pointer" onClick={handleProfileClick}>
          <User className="h-4 w-4 mr-2" />
          Profile
        </DropdownMenuItem>
        <DropdownMenuItem className="cursor-pointer" onClick={handleSOAPFormatClick}>
          <FileText className="h-4 w-4 mr-2" />
          SOAP Format
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem className="cursor-pointer" onClick={() => signOut()}>
          <LogOut className="h-4 w-4 mr-2" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}